import { ChangeDetectionStrategy, Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MarkdownComponent } from 'ngx-markdown';
import { GRID_EDGE_API_BRAND_NAME, LoaService } from '../service/loa/loa';

@Component({
  selector: 'app-terms-box',
  imports: [MarkdownComponent],
  templateUrl: './terms-box.html',
  styleUrl: './terms-box.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsBox implements OnInit {
  private http = inject(HttpClient);
  private loaService = inject(LoaService);

  brandName = input<string>(GRID_EDGE_API_BRAND_NAME);

  private rawContent = signal<string>('');

  content = computed(() =>
    this.loaService.applyBrandSubstitution(this.rawContent(), this.brandName())
  );

  /** Fetches the raw terms markdown from `assets/latest.md` on component init. */
  ngOnInit() {
    this.http.get('assets/latest.md', { responseType: 'text' }).subscribe(text => {
      this.rawContent.set(text);
    });
  }
}
